import { useEffect } from 'react'
import { supabase } from '@/config/supabase'
import { usePortalStore } from '@/stores/portal.store'

export function usePushNotifications() {
    const { associado, isAuthenticated } = usePortalStore()

    useEffect(() => {
        if (!isAuthenticated || !associado) return

        const registerPush = async () => {
            try {
                // 1. Verifica suporte
                if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
                    console.log('Push não suportado neste navegador');
                    return;
                }

                // 2. Aguarda o SW estar pronto
                const registration = await navigator.serviceWorker.ready;

                // 3. Solicita permissão
                const permission = await Notification.requestPermission();
                if (permission !== 'granted') {
                    console.log('Permissão de notificação negada');
                    return;
                }

                // 4. Obtém o token (PushSubscription)
                // Nota: vAPIDKey é necessário para produção. Para testes locais às vezes funciona sem ou com um dummy.
                // Mas o ideal é salvar o token no banco.
                const subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: 'BOnK8z-1J6f6N... (VAPID PUBLIC KEY)' // Ideal vir por env
                }).catch(async (err) => {
                    // Fallback se já existir
                    return await registration.pushManager.getSubscription();
                });

                if (subscription) {
                    const token = JSON.stringify(subscription);
                    
                    // 5. Salva no Supabase
                    const { error } = await supabase
                        .schema('veicular_system')
                        .from('veic_notificacao_push_tokens')
                        .upsert({
                            associado_id: associado.id,
                            token: token,
                            platform: navigator.userAgent.includes('Android') ? 'android' : 'web',
                            last_seen_at: new Date().toISOString()
                        }, { onConflict: 'token' });

                    if (error) console.error('Erro ao salvar token de push:', error);
                    else console.log('Token de push registrado com sucesso');
                }
            } catch (err) {
                console.error('Erro ao registrar push:', err);
            }
        };

        // Pequeno delay para não travar o carregamento inicial
        const timer = setTimeout(registerPush, 3000);
        return () => clearTimeout(timer);
    }, [isAuthenticated, associado]);
}
